import * as _ from 'lodash-es'

export const clearQuery = (query: Record<string, string | number | undefined>) => {
  return Object.keys(query).reduce(
    (acc, item) => {
      const value = query[item]
      if (value) acc[item] = String(value)
      return acc
    },
    {} as Record<string, string>,
  )
}

export const removeUndefinedFromObjcet = (obj: Record<string, string | number | undefined>) => {
  return _.omitBy(obj, _.isUndefined)
}
